<template>
  <v-dialog v-model="show" max-width="768">
    <v-card>
      <v-card-text class="pb-0">
        <WholesalerFinder :emitSubmitWholesaler.sync="submitSaler" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import WholesalerFinder from '@/components/wholesaler/FinderDialog'

export default {
  components: {
    WholesalerFinder,
  },
  data() {
    return {
      show: false,
      submitSaler: null,
      tempProduct: null,
    }
  },
  watch: {
    submitSaler(v) {
      if (v) {
        this.show = false
        this.tempProduct['wholesaler'] = v
        this.submitSaler = null
      }
    },
  },
  methods: {
    switchDialog(product) {
      this.tempProduct = product
      this.show = !this.show
    },
  },
}
</script>

<style lang="scss" scoped></style>
>
